import { Modal } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Input from "../../input/Input";
import styles from "./BillingCompanySelectionModal.module.scss";
import _ from "lodash";
import classNames from "classnames";
import Button from "../../button/Button";
import billingInvoicesService from "../../../apis/services/admin/billingInvoicesService";

const BillingCompanySelectionModal = ({
  modalOpen,
  onClose,
  onChoose,
  selectedBillingCompanyId,
}) => {
  const [selectedBillingCompany, setSelectedBillingCompany] = useState(null);
  const [billingCompanies, setBillingCompanies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const loadBillingCompanies = async (pageNum = 1, search = "") => {
    try {
      setLoading(true);
      const response = await billingInvoicesService.getBillingCompanies(pageNum, 20, search);
      const companiesData = response.data || [];
      let companiesArray = [];
      
      if (Array.isArray(companiesData)) {
        companiesArray = companiesData;
      } else if (companiesData && Array.isArray(companiesData.data)) {
        companiesArray = companiesData.data;
      }
      
      if (pageNum === 1) {
        setBillingCompanies(companiesArray);
      } else {
        setBillingCompanies(prev => [...prev, ...companiesArray]);
      }
      
      setHasMore(companiesArray.length === 20);
      setPage(pageNum);
    } catch (error) {
      console.error("Error loading billing companies:", error);
    } finally {
      setLoading(false);
    }
  };

  const searchBillingCompanies = _.debounce((search) => {
    setPage(1);
    loadBillingCompanies(1, search);
  }, 600);

  useEffect(() => {
    if (modalOpen) {
      loadBillingCompanies(1, "");
      if (selectedBillingCompanyId) {
        // Find and select the billing company if ID is provided
        billingInvoicesService.getBillingCompanies(1, 200, "")
          .then(response => {
            const allCompanies = response.data || [];
            const company = allCompanies.find(c => 
              c.id === parseInt(selectedBillingCompanyId) || 
              c.id.toString() === selectedBillingCompanyId.toString()
            );
            if (company) {
              setSelectedBillingCompany(company);
            }
          });
      }
    }
  }, [modalOpen]);

  useEffect(() => {
    if (searchTerm !== undefined) {
      searchBillingCompanies(searchTerm);
    }
  }, [searchTerm]);

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      loadBillingCompanies(page + 1, searchTerm);
    }
  };

  const handleChoose = () => {
    if (selectedBillingCompany) {
      onChoose(selectedBillingCompany);
      onClose();
    }
  };

  const renderItem = (company) => {
    return (
      <div
        className={classNames(
          styles.itemWrap,
          company?.id === selectedBillingCompany?.id && styles.selected
        )}
        onClick={() => {
          if (company?.id === selectedBillingCompany?.id) {
            setSelectedBillingCompany(null);
          } else {
            setSelectedBillingCompany(company);
          }
        }}
      >
        <div className={styles.configRow}>
          <div className={styles.configLabel}>
            <p className={styles.textBold}>Naziv:</p>
          </div>
          <div className={styles.configValue}>
            <p>{company.name}</p>
          </div>
        </div>
        <div className={styles.configRow}>
          <div className={styles.configLabel}>
            <p className={styles.textBold}>PIB:</p>
          </div>
          <div className={styles.configValue}>
            <p>{company.taxId || "-"}</p>
          </div>
        </div>
        {company.address && (
          <div className={styles.configRow}>
            <div className={styles.configLabel}>
              <p className={styles.textBold}>Adresa:</p>
            </div>
            <div className={styles.configValue}>
              <p>{company.address}</p>
            </div>
          </div>
        )}
        {company.contactEmail && (
          <div className={styles.configRow}>
            <div className={styles.configLabel}>
              <p className={styles.textBold}>Email:</p>
            </div>
            <div className={styles.configValue}>
              <p>{company.contactEmail}</p>
            </div>
          </div>
        )}
        {company.contactPhone && (
          <div className={styles.configRow}>
            <div className={styles.configLabel}>
              <p className={styles.textBold}>Telefon:</p>
            </div>
            <div className={styles.configValue}>
              <p>{company.contactPhone}</p>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal open={modalOpen} onClose={onClose}>
      <div className={styles.modalWrap}>
        <div className={styles.modalInner}>
          <p className={styles.title}>Izaberite fakturisku kompaniju</p>
          <div className={styles.inputWrapper}>
            <Input
              onChange={setSearchTerm}
              value={searchTerm}
              placeholder="Pretraži fakturiske kompanije..."
            />
          </div>
          <div className={styles.listWrapper}>
            {billingCompanies.map((company) => renderItem(company))}
            {loading && <p className={styles.loadingText}>Učitavanje...</p>}
            {hasMore && !loading && (
              <Button
                name="Učitaj više"
                onClick={handleLoadMore}
                type="button"
              />
            )}
            {billingCompanies.length === 0 && !loading && (
              <p className={styles.emptyText}>Nema fakturiskih kompanija</p>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            name="Odaberi"
            onClick={handleChoose}
            disabled={selectedBillingCompany === null}
          />
        </div>
      </div>
    </Modal>
  );
};

export default BillingCompanySelectionModal;

